/** @jsxImportSource @emotion/react */
"use client";

import type { ReactNode } from "react";

import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import { Button } from "../../_base/_core/Button/Button.emotion";

type AuthSubmitProps = {
  disabled: boolean;
  children: ReactNode;
  className?: string;
};

export const AuthSubmitButton = ({
  disabled,
  children,
  className = "",
}: AuthSubmitProps) => {
  const isDesktop = useIsDesktopViewport();
  return (
    <Button
      type="submit"
      disabled={disabled}
      size="l"
      isFullWidth={!isDesktop}
      className={className}
    >
      {children}
    </Button>
  );
};
